import React from 'react';

import UserLink from 'buyside/components/presentation/UserLink/userLink';
import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';

import { get } from 'buyside/util/lodashAltJs';

const Commenter = ({ comment, articleCaps = false, userLink = true, showCommenterName }) => {
  return (
    <span data-testid="commenter">
      {comment.anonUser || !showCommenterName ? (
        <AnonymousUserDisplay
          anonUser={
            comment.anonUser || { title: get(comment, ['user', 'mostRecentEmployer', 'title'], '') }
          }
          showArticle
          articleCaps={articleCaps}
        />
      ) : comment.user && userLink ? (
        <UserLink user={comment.user} />
      ) : (
        comment.user.displayName
      )}
    </span>
  );
};

export default Commenter;
